import { daysOfTheWeek, timeOptions } from 'utils/dates';

const options = () => {
  return daysOfTheWeek.map(({ label, value }) => ({
    label,
    value,
    options: timeOptions.map(({ startTime, endTime }) => ({
      label: `${startTime} - ${endTime}`,
      value: {
        day: value,
        startTime,
        endTime,
      },
    })),
  }));
};

export default options();
